<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'CREATE ENQUIRY' : 'UPDATE ENQUIRY'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-enquiry-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Enquiry Status</small>
                <v-select :clearable="false" placeholder="" v-model="form.status"
                          :options="['Pending', 'Completed']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const CrmRepository = RepositoryFactory.get('crm');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        notes: '',
        status: 'Pending'
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'CreateLeadInquiryPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchLeadEnquiryDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchLeadEnquiryDetails() {
        await this.$vs.loading({
          container: '#create-enquiry-popup',
          scale: 0.45
        })
        try {
          const {data} = (await CrmRepository.getLeadEnquiryDetails(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-enquiry-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-enquiry-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await CrmRepository.createLeadEnquiry( this.$route.params.id, this.form);
            this.showSuccessMessage('Lead enquiry created successfully!');
          } else {
            await CrmRepository.updateLeadEnquiry(this.id, this.form);
            this.showSuccessMessage('Lead enquiry updated successfully!');
          }
          await vue.$emit('refreshData');
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-enquiry-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-enquiry-popup > .con-vs-loading')
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
